export default __webpack_public_path__ + "static/media/apple-pay.94b77746.svg";